export const getDeadlineFormat = (deadline: Date) =>
  new Date(deadline)
    .toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })
    .replace(/at/g, '@');
